<template>
  <div>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="deleteRoleStatus"
      v-if="canDelete"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="editRoleStatus"
    >
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="orderUp">
      <i class="material-icons-outlined align-middle">arrow_upward</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="orderDown"
    >
      <i class="material-icons-outlined align-middle">arrow_downward</i>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      canDelete: true,
    };
  },
  beforeMount() {
    if (
      ["Submitted", "Accepted", "Added", "Rejected"].indexOf(
        this.params.data.name
      ) >= 0
    ) {
      this.canDelete = false;
    }
  },
  methods: {
    deleteRoleStatus: function () {
      this.params.context.componentParent.deleteRoleStatus(this.params.data);
    },
    editRoleStatus: function () {
      this.params.context.componentParent.editRoleStatus(this.params.data);
    },
    orderUp: function () {
      this.params.context.componentParent.orderUpRoleStatus(this.params.data);
    },
    orderDown: function () {
      this.params.context.componentParent.orderDownRoleStatus(this.params.data);
    },
  },
};
</script>
